import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import CreateCedulaModal from '../components/CreateCedulaModal';
import UpdateCedulaModal from '../components/UpdateCedulaModal';
import * as actions from '../action';
import * as c from '../constant';

function CedulaCalculations({ newOtherFeesId, removeCedulaFees, getNewOtherFeesList, getSingleNewOtherFees, history, cedulaCalculationList, getCedulaCalculationList, ordinanceRevisionId }) {
  const setModal = useContext(ModalContext);
  const handleAddCedulaModal = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <CreateCedulaModal newOtherFeesId={newOtherFeesId} cedulaCalculationList={cedulaCalculationList} ordinanceRevisionId={ordinanceRevisionId} />,
      title: 'Add Cedula Fee',
      modalSize: 'modal-md',
    });
  };

  const handleEditCedulaModal = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateCedulaModal newOtherFeesId={newOtherFeesId} ordinanceRevisionId={ordinanceRevisionId} updateList={data.attributes} id={data.id} cedulaCalculationList={cedulaCalculationList} />,
      title: 'Update Other Fee',
      modalSize: 'modal-md',
    });
  };

  const handleRemoveCedula = data => e => {
    e.preventDefault();

    ConfirmAlert(
      'Are you sure, you want to remove this cedula fee?',
      () => {
        removeCedulaFees(data.id, newOtherFeesId, () => {
          getNewOtherFeesList({ ordinance_revision_id: ordinanceRevisionId });
          history.push(`/bpls/tax-revenue/new-other-fees/${newOtherFeesId}`);
          getSingleNewOtherFees(newOtherFeesId);
          getCedulaCalculationList(newOtherFeesId);
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  return (
    <div>
      <Tabs>
        <TabList>
          <Tab>Cedula</Tab>
          {cedulaCalculationList.length !== 2 && (
            <div className="ml-auto m-1">
              <button
                type="button"
                className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4 ml-auto"
                onClick={handleAddCedulaModal}
              >
                Add Cedula Calculation
              </button>
            </div>
          )}
        </TabList>
        <TabPanel>
          <div className="p-3">
            <table className="transaction-table table table-bordered table-sm table-striped table-hover">
              <thead>
                <tr>
                  <td>Type</td>
                  <td>Fixed Fee</td>
                  <td>Base Fee</td>
                  <td>For Every Fee</td>
                  <td>Additional Fee</td>
                  <td>Max Fee</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                {!_.isEmpty(cedulaCalculationList) ?
                  cedulaCalculationList.map(item => (
                    <tr key={item.id} className="top-border">
                      <td className="text-left">
                        {_.get(item, 'attributes.business_type')}
                      </td>
                      <td className="text-left">
                        {_.get(item, 'attributes.cedula_fixed_fee')}
                      </td>
                      <td className="text-left">
                        {_.get(item, 'attributes.cedula_base_fee')}
                      </td>
                      <td className="text-left">
                        {_.get(item, 'attributes.cedula_for_every_fee')}
                      </td>
                      <td className="text-left">
                        {_.get(item, 'attributes.cedula_additional_fee')}
                      </td>
                      <td className="text-left">
                        {_.get(item, 'attributes.cedula_max_fee')}
                      </td>
                      <td className="text-center">
                        <button
                          type="button"
                          className="btn-blank"
                          onClick={handleEditCedulaModal(item)}
                        >
                          <i className="far fa-edit icon-edit" />
                        </button>
                        <button
                          type="button"
                          className="btn-blank"
                          onClick={handleRemoveCedula(item)}
                        >
                          <i className="far fa-trash-alt icon-delete" />
                        </button>
                      </td>
                    </tr>
                  )) : (
                    <tr className="text-center">
                      <td colSpan="7">No data</td>
                    </tr>
                  )
                }
              </tbody>
            </table>
          </div>
        </TabPanel>
      </Tabs>
    </div>
  )
}

CedulaCalculations.propTypes = {
  cedulaCalculationList: PropTypes.instanceOf(Object).isRequired,
  removeCedulaFees: PropTypes.instanceOf(Function).isRequired,
  getNewOtherFeesList: PropTypes.instanceOf(Function).isRequired,
  getSingleNewOtherFees: PropTypes.instanceOf(Function).isRequired,
  getCedulaCalculationList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  newOtherFeesId: PropTypes.string.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired
};

const mapStateToProps = ({ api }) => ({
  cedulaCalculationList: _.get(api, `${c.GET_CEDULA_CALCULATION_LIST}.list`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(CedulaCalculations);